
  <div class="container" style="margin-top: 30px;">
      <data-table
      [title]='titleActividades'
      [columns]='columnasActividades'
      [data]='dataActividades'
      [configuration]='configurationActividades'
      [reloadTable]='recargarTablaActividades'
      (add)='addActivity()'
      (edit)='editActivity($event)'
      (delete)='deleteActivity($event)'
      [headerFilters]='headerFilters'
      [params]='[]'
      [url]='urlTableActivities'
      ></data-table>
</div>




